"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackEvent = trackEvent;
exports.trackIdentifyUser = trackIdentifyUser;
exports.trackGoogleAnalyticsEvent = trackGoogleAnalyticsEvent;
exports.trackGoogleTagManagerEvent = trackGoogleTagManagerEvent;
exports.trackUserCreated = trackUserCreated;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.search.js");

/* eslint-disable camelcase */
function getPageContext() {
  var _window, _window$zola;

  return {
    path: window.location.pathname,
    search: window.location.search,
    referrer: ((_window = window) === null || _window === void 0 ? void 0 : (_window$zola = _window.zola) === null || _window$zola === void 0 ? void 0 : _window$zola.referrer) || document.referrer,
    url: window.location.href,
    title: document.title
  };
}

function trackEvent(eventName, payload) {
  var _window2, _window2$analytics;

  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var optionsFinal = options || {};
  optionsFinal.page = getPageContext();

  if ((_window2 = window) !== null && _window2 !== void 0 && (_window2$analytics = _window2.analytics) !== null && _window2$analytics !== void 0 && _window2$analytics.track) {
    window.analytics.track(eventName, payload, optionsFinal);
  }
}

function trackIdentifyUser(userId, traits, options) {
  var optionsFinal = options || {};
  optionsFinal.page = getPageContext();

  if (window && window.analytics) {
    window.analytics.identify(userId, traits, optionsFinal);
  }
}

/**
 * Sends an event to GA through Segment.  Does not go ot other Segment destinations.
 * https://segment.com/docs/connections/destinations/catalog/google-analytics/#track
 * @param eventName The Event name will become the action in GA
 * @param payload
 */
function trackGoogleAnalyticsEvent(eventName, payload) {
  var options = {
    integrations: {
      All: false,
      'Google Analytics': true
    }
  };
  trackEvent(eventName, payload, options);
}
/**
 * Fires a GTM event.  Does not go to other Segment destinations.
 * @param eventName
 * @param payload payload data will be pushed to the dataLayer
 */


function trackGoogleTagManagerEvent(eventName, payload) {
  var options = {
    integrations: {
      All: false,
      'Google Tag Manager': true
    }
  };
  trackEvent(eventName, payload, options);
}

function trackUserCreated(email, pkey) {
  var payload = {
    email: email,
    pkey: pkey
  };
  trackEvent('User Created', payload);
}